/**
 * card-lowest-variant-sfapi.js
 *
 * Product cards: link to the cheapest IN-STOCK variant.
 *
 * Liquid only sees a product's first 250 variants, so for bigger products
 * product-item.liquid knows the right PRICE (product.price_min) but has no
 * variant id to link to. This script fills that gap with the Storefront API.
 *
 * Runs ONLY for cards Liquid marked data-needs-lowest (variants_count > 250),
 * and only when the card scrolls into view. Cached 5 min in sessionStorage.
 *
 * Stock rule matches the bulk order form: a variant counts as buyable when it
 * is availableForSale AND has stock in at least one warehouse. Products with no
 * warehouse metafields fall back to availableForSale alone.
 */
;(function () {
  var CFG = window.CCSearchCfg || window.variantPickerConfig || {};
  var TOKEN = CFG.token || CFG.apiToken || '';
  var DOMAIN = CFG.domain || CFG.shopDomain || window.location.host;
  if (!TOKEN) return; // no token: leave every card exactly as Liquid rendered it

  var API = 'https://' + DOMAIN + '/api/2024-01/graphql.json';
  var PAGE = 250;
  var CACHE_MS = 5 * 60 * 1000;
  var CACHE_PREFIX = 'cts_card_low_';
  var WH_KEYS = ['toronto_on', 'calgary_ab', 'vancouver_bc'];
  var done = new WeakSet();

  var WH_FIELDS = 'metafields(identifiers:[' + WH_KEYS.map(function (k) {
    return '{namespace:"custom",key:"' + k + '"}';
  }).join(',') + ']){key value}';

  var QUERY =
    'query($handle:String!,$cursor:String){' +
    ' productByHandle(handle:$handle){' +
    '  variants(first:' + PAGE + ', after:$cursor){' +
    '   pageInfo{hasNextPage endCursor}' +
    '   edges{node{ id availableForSale price{amount} ' + WH_FIELDS + ' }}' +
    '  }' +
    ' }' +
    '}';

  function inStock(node) {
    if (!node.availableForSale) return false;
    var mfs = (node.metafields || []).filter(Boolean);
    if (!mfs.length) return true; // no warehouse data: trust availableForSale
    return mfs.some(function (m) { return parseInt(m.value, 10) > 0; });
  }

  function readCache(handle) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + handle);
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || !c.t || Date.now() - c.t > CACHE_MS || !c.v) return null;
      return c.v;
    } catch (e) { return null; }
  }
  function writeCache(handle, v) {
    try { sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify({ t: Date.now(), v: v })); }
    catch (e) { /* quota / private mode */ }
  }

  function gql(handle, cursor) {
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
      body: JSON.stringify({ query: QUERY, variables: { handle: handle, cursor: cursor } })
    }).then(function (r) { return r.json(); });
  }

  // Walks every page, keeps the cheapest buyable variant (falls back to the
  // cheapest overall if nothing is buyable, so the link is never empty).
  function findLowest(handle, cursor, best, bestAny, resolve) {
    gql(handle, cursor).then(function (data) {
      var p = data && data.data && data.data.productByHandle;
      if (!p || !p.variants) { resolve(best || bestAny); return; }

      p.variants.edges.forEach(function (e) {
        var n = e.node;
        var price = parseFloat(n.price.amount);
        if (isNaN(price)) return;
        var id = n.id.replace('gid://shopify/ProductVariant/', '');
        if (!bestAny || price < bestAny.price) bestAny = { id: id, price: price };
        if (inStock(n) && (!best || price < best.price)) best = { id: id, price: price };
      });

      if (p.variants.pageInfo.hasNextPage) {
        findLowest(handle, p.variants.pageInfo.endCursor, best, bestAny, resolve);
      } else {
        resolve(best || bestAny);
      }
    }).catch(function () { resolve(best || bestAny); });
  }

  function applyToCard(card, best) {
    if (!best || !best.id) return;
    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (!href) continue;
      links[i].setAttribute('href', href.split('?')[0].split('#')[0] + '?variant=' + best.id);
    }
  }

  function fix(card) {
    if (done.has(card)) return;
    done.add(card);
    var handle = card.getAttribute('data-product-handle');
    if (!handle) return;

    var cached = readCache(handle);
    if (cached) { applyToCard(card, cached); return; }

    findLowest(handle, null, null, null, function (best) {
      if (!best) return;
      writeCache(handle, best);
      applyToCard(card, best);
    });
  }

  var observer = window.IntersectionObserver
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { observer.unobserve(e.target); fix(e.target); }
        });
      }, { rootMargin: '200px' })
    : null;

  function scan() {
    var cards = document.querySelectorAll('[data-needs-lowest]:not([data-low-seen])');
    for (var i = 0; i < cards.length; i++) {
      cards[i].setAttribute('data-low-seen', '1');
      if (observer) observer.observe(cards[i]); else fix(cards[i]);
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); }
  else { scan(); }
  document.addEventListener('shopify:section:load', scan); // filters / section reload
  if (window.MutationObserver) {                            // infinite scroll, quick view
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; scan(); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();